// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"e53d270d31ea4c4f642a","293":"cfe8aba639e6ed9288fb","518":"6327a0f6245351518bda","779":"425388095533d3a340d3"}[chunkId] + ".js";
};